module.exports = __webpack_public_path__ + "img/intellimat-3.73c834ce.png";